import { motion } from "framer-motion"
import { Link, defer, useLoaderData, useLocation, Await, Outlet } from "react-router-dom";
import ApiServices from "../../service/ApiServices";
import { Suspense } from "react";

import "./history.css";

import { Spinner } from "../template/spinner/spinner";
import { Actual } from "./tabs/actual";

const History = () => {

    const {pathname} = useLocation();

    const {orders} = useLoaderData();

    return (
        <div className="container">
            <div className="row mt-2">
                <div className="col-12 d-flex justify-content-center">
                    <Link to="/history"
                            className={pathname === '/history' ? 'active history-nav-link' : 'history-nav-link'}>
                        Актуальні
                    </Link>
                    <Link to="/history/completed"
                            className={pathname === '/history/completed' ? 'active history-nav-link' : 'history-nav-link'}>
                        Завершені
                    </Link>
                </div>
            </div>
                <Suspense fallback={<Spinner/>}>
                    <Await resolve={orders}>
                    {pathname === '/history' 
                        ?
                        <Actual/>
                        :
                        <Outlet/>
                    }
                    </Await>
                </Suspense>
        </div>
    )
}

const res = new ApiServices();

const historyLoader = ({params}) => {
    const query = params !== '' ? params['*'] : null;
    const customer = JSON.parse(localStorage.getItem('customer'));

    if (customer === null) {
        return {orders: []};
    }

    return defer({
        orders: res.getHistory({query, customer: customer.phone}),
    })
}

export { History, historyLoader };